export default function Donut({ data, size = 160, thickness = 22, centerLabel, centerSub }) {
  const items = (data || []).filter((d) => (d.value || 0) > 0);
  const total = items.reduce((acc, d) => acc + (d.value || 0), 0) || 1;
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  let offset = 0;

  return (
    <div className="flex items-center justify-center gap-4">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(148,163,184,0.12)" strokeWidth={thickness} />
        {items.map((d, i) => {
          const frac = (d.value || 0) / total;
          const dash = Math.max(frac * c - 1.5, 1);
          const seg = (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={d.color}
              strokeWidth={thickness}
              strokeDasharray={`${dash} ${c - dash}`}
              strokeDashoffset={-offset}
              strokeLinecap="butt"
            />
          );
          offset += frac * c;
          return seg;
        })}
      </svg>
      <div className="text-center">
        <p className="text-2xl font-bold text-dark-100">{centerLabel}</p>
        {centerSub && <p className="text-xs text-dark-500">{centerSub}</p>}
      </div>
    </div>
  );
}